import { jsx as _jsx } from "react/jsx-runtime";
import Grid from '@mui/material/Grid';
import { FilterItemType } from './types';
import { Input } from '../input';
import { MultiSelect } from '../select';
import { Checkbox } from '../checkbox';
const getComponentByType = ({ type, props, onChange, value, render, }) => {
    var _a;
    switch (type) {
        case FilterItemType.Input:
            return _jsx(Input, Object.assign({ defaultValue: value }, props, { onChange: onChange }));
        case FilterItemType.Select:
            return (_jsx(MultiSelect, Object.assign({ defaultValue: value }, props, { onChange: onChange, multiple: false })));
        case FilterItemType.Multiselect:
            // to solve a problem we pass default value but options are not loaded yet
            const defaultValue = ((_a = props.options) === null || _a === void 0 ? void 0 : _a.length) ? value : undefined;
            return (_jsx(MultiSelect, Object.assign({ defaultValue: defaultValue }, props, { onChange: onChange }), defaultValue));
        case FilterItemType.Checkbox:
            return (_jsx(Checkbox, Object.assign({}, props, { onChange: onChange, defaultChecked: value, className: "mt-5" })));
        case FilterItemType.Custom:
            return render === null || render === void 0 ? void 0 : render(Object.assign(Object.assign({}, props), { onChange, defaultValue: value }));
        default:
            return null;
    }
};
export const FilterFactory = ({ items, onChange, data = {}, }) => {
    return (_jsx(Grid, { container: true, spacing: 2, "data-testid": "filter-factory", children: items.map((item, index) => {
            var _a;
            const value = data[item.props.name || ((_a = item.props.inputProps) === null || _a === void 0 ? void 0 : _a.name)];
            const component = getComponentByType({
                type: item.type,
                props: item.props,
                onChange,
                value,
                render: item.render,
            });
            return (_jsx(Grid, { item: true, sm: item.size, xs: item.size * 3, children: component }, item.id || index));
        }) }));
};
export default FilterFactory;
